// src/features/collaboration/components/PostList.js
import React from 'react';
import { Box, Divider } from '@mui/material';
import Post from './Post';

const PostList = ({ posts }) => {
  return (
    <Box sx={{ width: '100%' }}>
      {posts.map((post, index) => (
        <React.Fragment key={post.id}>
          <Post post={post} />
          {index < posts.length - 1 && <Divider sx={{ my: 2 }} />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default PostList;